import { useEffect, useState } from "react";
import styled, { createGlobalStyle } from 'styled-components';
import CustomSmallButton from "../../../../../../../../../components/button/CustomSmallButton";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react-wrapper';
import { v4 as uuidv4 } from 'uuid';
import { ContextMenu } from "handsontable/plugins";
import { registerRenderer, textRenderer } from "handsontable/renderers";
import { FragmentItemsCheckStep } from "./fragments/fragment-items-check-step";
import { FragmentMergeLocationSelectStep } from "./fragments/fragment-merge-location-select-step";
import axios from "axios";
import { SellertoolSignatureUtils } from "../../../../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../../../../contexts/ApiInfoContextProvider";
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";
import { CustomBackdropController } from "../../../../../../../../../components/backdrop/default/v1";

const StyledContainer = styled.div`
`;
const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function WegetSetting({
    editTargetPallet,
    pallets,
    loadItems,
    selectedRackLocation,
    onPrevToDefault,
    onCloseModal,
    onReqFetch,
    apiResource = 'pallets'
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [viewType, setViewType] = useState('ITEMS_CHECK'); // RACK, PALLET
    const [mergingLocationActive, setMergingLocationActive] = useState(false);
    const [editableItems, setEditableItems] = useState([]);

    const targetPalletLoadItems = loadItems?.filter(item => item?.palletUUID === editTargetPallet?.uuid);

    useEffect(() => {
        let items = [];
        selectedRackLocation?.items?.forEach(item => {
            items.push({
                uuid: item?.uuid,
                productName: item?.productName,
                optionName: item?.optionName,
                boxQuantity: item?.boxQuantity || 0,
                productQuantity: item?.productQuantity || 0,
                optionCode: item?.optionCode,
                isNew: false
            })
        });
        targetPalletLoadItems?.forEach(item => {
            items.push({
                uuid: item?.uuid,
                productName: item?.productName,
                optionName: item?.optionName,
                boxQuantity: item?.boxQuantity || 0,
                productQuantity: item?.estimatedProductQuantity || 0,
                optionCode: item?.optionCode,
                isNew: true
            });
        });

        setEditableItems(items);
    }, []);

    const handleClearExistedItems = () => {
        setEditableItems(prev => {
            return prev?.filter(item => item?.isNew || !item?.uuid);
        })
    }

    const handleNextStep = () => {
        setEditableItems(prev => {
            return prev.map(item => {
                if (!item?.uuid) {
                    return {
                        uuid: uuidv4(),
                        productName: item?.productName || '',
                        optionName: item?.optionName || '',
                        boxQuantity: item?.boxQuantity || 0,
                        productQuantity: item?.productQuantity || 0,
                        optionCode: item?.optionCode || '',
                        isNew: true
                    }
                }
                return item;
            })
        });
        setViewType('MERGE_LOCATION');
    }

    const handlePrevStepToItemsCheck = () => {
        setViewType('ITEMS_CHECK');
    }

    const handleSubmitReflection = async () => {
        const newItems = editableItems?.map(item => {
            if (item?.isNew) {
                return {
                    uuid: uuidv4(),
                    productName: item?.productName || '',
                    optionName: item?.optionName || '',
                    boxQuantity: item?.boxQuantity ? Number(isNaN(item?.boxQuantity) ? 0 : item?.boxQuantity) : 0,
                    productQuantity: item?.productQuantity ? Number(isNaN(item?.productQuantity) ? 0 : item?.productQuantity) : 0,
                    optionCode: item?.optionCode || '',
                }
            }
            return {
                uuid: item?.uuid,
                productName: item?.productName || '',
                optionName: item?.optionName || '',
                boxQuantity: item?.boxQuantity ? Number(isNaN(item?.boxQuantity) ? 0 : item?.boxQuantity) : 0,
                productQuantity: item?.productQuantity ? Number(isNaN(item?.productQuantity) ? 0 : item?.productQuantity) : 0,
                optionCode: item?.optionCode || '',
            }
        })
        const newRackLocation = {
            ...selectedRackLocation,
            items: newItems,
            enabledYn: newItems?.length <= 0 ? 'y' : 'n',
        }
        const mergeRackLocationAddress = mergingLocationActive ? getMergingLocationAddress(newRackLocation?.address) : null;

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            newRackLocation: newRackLocation,
            mergeRackLocationAddress: mergeRackLocationAddress,
            pallet: editTargetPallet,
        }

        CustomBackdropController().showBackdrop();
        const reflectResponse = await axios.post(`${API_HOST}/${apiResource}/reflect-rack-location-one`, body, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (reflectResponse?.content) {
            onCloseModal();
            onReqFetch();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>

            <StyledContainer>
                {viewType === 'ITEMS_CHECK' &&
                    <FragmentItemsCheckStep
                        editableItems={editableItems}
                        onClearExistedItems={handleClearExistedItems}
                        onNextStep={handleNextStep}
                        onPrevToDefault={onPrevToDefault}
                    />
                }
                {viewType === 'MERGE_LOCATION' &&
                    <FragmentMergeLocationSelectStep
                        selectedRackLocation={selectedRackLocation}
                        mergingLocationActive={mergingLocationActive}
                        setMergingLocationActive={setMergingLocationActive}
                        onPrevStepToItemsCheck={handlePrevStepToItemsCheck}
                        onSubmitReflection={handleSubmitReflection}
                    />
                }
            </StyledContainer>
        </>
    );
}

function getMergingLocationAddress(address) {
    const addressSplit = address?.split('-');
    if (addressSplit.length < 5) return address; // 잘못된 형식일 경우 원래 주소 반환

    const rack = addressSplit[1];
    const bay = addressSplit[2];
    const level = addressSplit[3];
    const position = addressSplit[4];

    // position 값이 01이면 02로, 02면 01로 변경
    const newPosition = position === '01' ? '02' : '01';

    return `Z-${rack}-${bay}-${level}-${newPosition}`;
}